<template>
<div class="chapter">
<div class="inner_page">
<a id="page_6"></a>
<h2 class="fm_head" id="ack">ACKNOWLEDGEMENTS</h2>
<p class="noindentt"><span class="dropcaps">F</span>irst and foremost, I would like to thank my wife Helen for encouraging me to contact Pen and Sword about this project. A big thank you also goes to Roger Warwick; without his excellent series on United Counties, this book would not have been possible, for allowing me to use information from this series, and providing much needed assistance with photographs. Steve Loveridge and Gary Seamarks for taking the time to proofread my work and providing photographs. Lastly, my thanks go to Liam Farrer-Beddall, David Hancock, Simon Butler, the 794 Preservation Group, Graham Smith, Bruce Pyne, Thomas Knowles and Tony Burgoyne for providing additional photographs for this project.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Acknowledge.vue?5816b8d4